export interface FormValues {
  name: string;
}
export default function mapPropsToValues() {
  return {
    name: "",
  };
}
